<template>
	<div>
		<table class="grid_tbl_85" border="0">
			<colgroup>
				<col v-for="i in 12" :key="i" :style="{ width: 100 / 12 + '%' }" />
			</colgroup>
			<tr v-for="(dv_list, index) in dv_double_list" :key="index">
				<template v-if="dv_list && dv_list.length > 0">
					<td v-for="(dv, jIndex) in dv_list" :rowspan="dv.rowspan_cnt" :colspan="dv.colspan_cnt" :key="index + '/' + jIndex">
						<div v-if="dv.view_code" class="brick" style="height: 100%; padding-right: 10px;">
							<GraphInGrid :view_code="dv.view_code" :rowspan_cnt="dv.rowspan_cnt" :colspan_cnt="dv.colspan_cnt" />
						</div>
					</td>
				</template>
			</tr>
		</table>

		<span id="custom_graph_tooltip" class="tip_span"></span>
	</div>
</template>

<script>
import GraphInGrid from '@/views/statistics/GraphInGrid';
import { apiGetDashboardViewLocationList } from '@/api/statistics/statistics.js';
import { inputSelectOnClick } from '@/utils/etc.js';
export default {
	data: () => ({
		// view위치 일단 고정
		dv_double_list: [
			[
				{
					view_start_col: 1,
					dv_location_no: 1,
					view_code: 'GPT',
					view_end_col: 6,
					company_id: '',
					user_id: 'argonet_admin',
					view_start_row: 1,
					view_end_row: 1,
					colspan_cnt: 6,
					rowspan_cnt: 1,
				},
				{
					view_start_col: 7,
					dv_location_no: 5,
					view_code: 'ICG',
					view_end_col: 12,
					company_id: '',
					user_id: 'argonet_admin',
					view_start_row: 1,
					view_end_row: 1,
					colspan_cnt: 6,
					rowspan_cnt: 1,
				},
				/*
				{
					view_start_col: 7,
					dv_location_no: 2,
					view_code: 'ARD',
					view_end_col: 12,
					company_id: '',
					user_id: 'argonet_admin',
					view_start_row: 1,
					view_end_row: 1,
					colspan_cnt: 6,
					rowspan_cnt: 1,
				},*/
			],
			[
				{
					view_start_col: 1,
					dv_location_no: 3,
					view_code: 'BSL',
					view_end_col: 6,
					company_id: '',
					user_id: 'argonet_admin',
					view_start_row: 2,
					view_end_row: 2,
					colspan_cnt: 6,
					rowspan_cnt: 1,
				},
				{
					view_start_col: 7,
					dv_location_no: 4,
					view_code: 'SGR',
					view_end_col: 12,
					company_id: '',
					user_id: 'argonet_admin',
					view_start_row: 2,
					view_end_row: 2,
					colspan_cnt: 6,
					rowspan_cnt: 1,
				},
			],
		],
	}),
	components: {
		GraphInGrid,
	},
	methods: {
		// 요구 사항 접수 후 조회권한 및 dashboard_view작업 재개
		async getDashboardViewLocationList() {
			let { data } = await apiGetDashboardViewLocationList();
			this.dv_double_list = data;
		},
	},
	async created() {
		// await this.getDashboardViewLocationList();

		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_dashboard');
		this.$store.commit('setSubTitle', 'Report -> Dashboard');
	},
	mounted() {
		this.$nextTick(() => inputSelectOnClick());
	},
};
</script>

<style scoped>
.grid_tbl_85 {
	width: 85%;
}

[class^='grid_tbl_'] td {
	height: 450px;
	padding: 10px;
}

.tip_span {
	display: none;
	position: absolute;
	width: 150px;
	padding: 5px;
	z-index: 100;
	background: #c4d5ff;
	color: #000;
	border-radius: 5px; /* 파폭 박스 둥근 정도 */
	-webkit-border-radius: 5px; /* 사파리 박스 둥근 정도 */
}
</style>
